import { useStore } from '@/providers/app-store-provider';
import { useEffect } from 'react';

export default function useEffectWithCurReady(effect: () => void | (() => any), deps: any[]) {
  const currencyReady = useStore((state) => state.currencyReady);

  useEffect(() => {
    if (!currencyReady) return;
    return effect();
  }, [currencyReady, ...deps]);
}
